module.exports = ".custom_color{\n    color:white\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cases/css/case.component.css
// module id = ./src/app/modules/cases/css/case.component.css
// module chunks = main